import { FC, Link, Row} from 'external/react'
import useParent from 'context/parent-context/hook'

import Icon from 'external/fortawesome'
import { clsx } from 'external/clsx'

const SelectUserRole:FC = () => {

    const {navigation, params: {role}} = useParent()
	return (
        <fieldset className='border rounded-3 p-3' style={{minWidth: '600px'}}>
            <legend className='float-none w-auto px-2 fs-6'>
                Rol del usuario
            </legend>
            <Row
                style={{ fontSize: '16px' }}
                className='d-flex justify-content-center align-items-center'
            >
                <Link to={navigation.newUser.link({role: 'student'})} style={{ width: '260px' }} className={clsx('user-rol__filter d-flex justify-content-center align-items-center mb-3 fa-2x mb-3', {selected: role === 'student'})}>
                    <Icon name='faGraduationCap' /> Estudiante
                </Link>
           </Row>
            <Row
                style={{ fontSize: '16px' }}
                className='d-flex justify-content-center align-items-center'
            >
                <Link to={navigation.newUser.link({role: 'tutor'})} style={{ width: '260px' }} className={clsx('user-rol__filter d-flex justify-content-center align-items-center mb-3 fa-2x mb-3', {selected: role === 'tutor'})}>
                   <Icon name='faPersonChalkboard' /> Tutor
                </Link>
            </Row>
        </fieldset>
)
}

export {SelectUserRole as default}